// @flow
import React, { Fragment, useContext } from 'react';

import { useRouter } from 'Client/router/useRouter';
import ReactAppContext from 'Context/ReactAppContext';
import { isSeller } from 'Utils/seller/sellerUtils';
import { getConfigWithNoThirdPartySupport } from './thirdParty.utils';

export const GoogleTagManager = () => {
  const {
    location: { queryParams },
  } = useRouter<UrlParams, GlobalQueryParams>();
  const appContext = useContext(ReactAppContext);
  const tracking = getConfigWithNoThirdPartySupport({
    name: 'tracking',
    locale: appContext.locale,
    queryParams,
  });

  let key = 'GTM-KJ3DSC';
  if (isSeller(appContext)) {
    key = appContext.isCmta ? 'GTM-P9H7QS7' : 'GTM-N8CQ3J6';
  }

  if (tracking.enabled) {
    return (
      <Fragment>
        <noscript>
          <iframe
            title="googletagmanager"
            src={`https://www.googletagmanager.com/ns.html?id=${key}`}
            height="0"
            width="0"
            style={{ display: 'none', visibility: 'hidden' }}
          />
        </noscript>
        <script
          dangerouslySetInnerHTML={{
            __html: `
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','clubMedLayer','${key}');
          `,
          }}
        />
      </Fragment>
    );
  }

  return null;
};
